import recursiveFunctionStepParser from '../recursiveFunctionStepParser';
import functionResponseObjectExtractor from '../general/functionResponseObjectExtractor';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={},
    setStateFunction
){
    try{
        let updatedVariables = variableObject;
        const {
            executionObject={}
        } = functionObj;
        const {
            iterationId='',
            functionObject={},
        } = executionObject;

        const {
            functionSteps=[]
        } = functionObject;
        let normalizedFunctionSteps = [], responseObject={};
        for (let k = 0; k < functionSteps.length; k++){
            let workflow = functionSteps[k];
            let steps = workflow['functionSteps'] || [];
            normalizedFunctionSteps.push(...steps);
        }

        if(navigator.geolocation){
            const watchId = navigator.geolocation.watchPosition(
                async position => {
                    parameterObject[`userPosition_${iterationId}`] = position;
                    await recursiveFunctionStepParser(
                        normalizedFunctionSteps,
                        updatedVariables,
                        parameterObject,
                        functionMap,
                        variableIdMap,
                        setStateFunction
                    );
                },
                error => {
                    console.log('watchPositionParser error', error);
                }
            );
            // Store so a clearWatchPosition step can stop it later
            parameterObject[`watchPositionId_${iterationId}`] = watchId;
        }

        return {
            hasError: false,
            errorPayload: undefined,
            hasReturnStatement: false,
            returnStatement: undefined,
            updatedVariableObject: updatedVariables
        };
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/watchPositionParser catch block error', e)
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}